var map = {
	"./Asepto-pump-1200x1200.png": 5220,
	"./Electra-1200x1200.png": 3606,
	"./FlatDrain-1200x1200.png": 7694,
	"./Grounding-Pad-1200x1200.png": 7533,
	"./Mini-Vac-set-1200x1200.png": 222,
	"./Romo-ADK-1200x1200.png": 5641,
	"./Romo-Vac-Set-1200x1200.png": 1714,
	"./VaccuSuckRI-1200x1200.png": 8431,
	"./VentiSuck-1200x1200.png": 838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9956;